// Agent-type identifiers, one per conversational agent. Each must match the
// `Agent#agent_type` of the corresponding seeder in db/seeds/agents/.
//
// These live in their own dependency-free module because both the page-level
// atom files and the agent wrapper components need them. Putting them in either
// of those layers would make one import the other and risk a cycle.

export const TITLE_WORKSPACE_AGENT_TYPE = 'title_workspace_agent';
export const TITLE_SUPPORT_WORKSPACE_AGENT_TYPE =
  'title_support_workspace_agent';
export const DOCUMENT_AGENT_TYPE = 'document_agent';
// Separate definition from the document agent — different record, different brief,
// and only this one can stage a change. This one and the document agent present to
// the user as "Insights Agent"; see the `agentName` on each agent definition. The
// title workspace agent is not yet part of that convention.
export const EVAL_AGENT_TYPE = 'eval_agent';
